"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
var _zhjySerach = _interopRequireDefault(require("@/components/search/zhjySerach.vue"));
var _funBtn = _interopRequireDefault(require("@/components/funBtn/funBtn.vue"));
var _zhjyTable = _interopRequireDefault(require("@/components/table/zhjyTable.vue"));
var _zhjyPagination = _interopRequireDefault(require("@/components/zhjyPagination/zhjyPagination.vue"));
var _news = require("@/api/news/news");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      queryValue: "",
      queryGroup: [{
        label: "精确查找",
        type: "input",
        model: "queryValue",
        placeholder: "名称/编码"
      }],
      modelData: {
        queryValue: ""
      },
      defaultColumn: [{
        name: "标题",
        prop: "newsTitle",
        isShow: true,
        width: "250"
      }, {
        name: "所属新闻分类",
        prop: "newsTypeName",
        isShow: true,
        width: "250"
      }, {
        name: "排序",
        prop: "sort",
        isShow: true,
        width: "100"
      }, {
        name: "状态",
        prop: "status",
        isShow: true,
        width: "100",
        isFormats: true
      }, {
        name: "创建时间",
        prop: "createTime",
        isShow: true,
        width: "200",
        sortable: true
      }],
      minWidth: 300,
      page: {
        pageNumber: 1,
        pageSize: 10
      },
      totalData: 0,
      listData: [],
      formatters: {
        status: [{
          name: "已发布",
          value: "1"
        }, {
          name: "未发布",
          value: "0"
        }]
      },
      sort: {
        prop: "",
        order: ""
      },
      newsInfo: {
        newsTitle: "",
        newsType: ""
      },
      checkBoxs: []
    };
  },
  methods: {
    // 获取新闻列表
    getNewsList: function getNewsList() {
      var _this = this;
      (0, _news.newList)({
        newsTitle: this.queryValue,
        newsType: "",
        pageNum: this.page.pageNumber,
        pageSize: this.page.pageSize
      }).then(function (res) {
        var data = res.data;
        _this.listData = data.list;
        _this.totalData = data.total;
      });
    },
    // 编辑新闻
    edit: function edit(e) {
      this.$router.push({
        path: "/webSet/webSet-news-edit",
        query: {
          id: e.id
        }
      });
    },
    // 新增
    add: function add() {
      this.$router.push("/webSet/webSet-news-add");
    },
    // 搜索
    search: function search(val) {
      this.queryValue = val.queryValue;
      this.getNewsList();
    },
    // 批量发布
    allPush: function allPush() {
      var _this2 = this;
      if (!this.checkBoxs || this.checkBoxs.length === 0) {
        return this.$message.error("请先勾选数据");
      } else {
        (0, _news.pushNews)({
          idList: this.checkBoxs,
          status: 1
        }).then(function (res) {
          _this2.$message.success("操作成功。");
          _this2.getNewsList();
        });
      }
    },
    // 取消发布
    morePublish: function morePublish() {
      var _this3 = this;
      if (!this.checkBoxs || this.checkBoxs.length === 0) {
        return this.$message.error("请先勾选数据");
      } else {
        (0, _news.pushNews)({
          idList: this.checkBoxs,
          status: 0
        }).then(function (res) {
          _this3.$message.success("操作成功。");
          _this3.getNewsList();
        });
      }
    },
    handleSelectionChange: function handleSelectionChange(row) {
      var _this4 = this;
      this.checkBoxs = [];
      row.forEach(function (item) {
        _this4.checkBoxs.push(item.id);
      });
    },
    // 删除
    deleteById: function deleteById(row) {
      var _this5 = this;
      var id = [];
      if (!row && this.checkBoxs.length === 0) {
        return this.$message.error("请先勾选数据");
      } else if (row) {
        id.push(row.id);
      } else if (this.checkBoxs.length > 0) {
        id = this.checkBoxs;
      }
      this.$confirm("确认删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      }).then(function () {
        (0, _news.delNews)({
          idList: id
        }).then(function () {
          _this5.$message.success("操作成功。");
          _this5.getNewsList();
        });
      }).catch(function () {
        _this5.$message.info("取消删除。");
      });
    },
    distribution: function distribution() {},
    viewAdmin: function viewAdmin() {},
    sortChange: function sortChange() {},
    handleCurrentChange: function handleCurrentChange(e) {
      this.page.pageNumber = e;
      this.getNewsList();
    },
    handleSizeChange: function handleSizeChange(e) {
      this.page.pageSize = e;
      this.page.pageNumber = 1;
      this.getNewsList();
    }
  },
  created: function created() {
    this.getNewsList();
  },
  components: {
    ZhjySerach: _zhjySerach.default,
    ZhjyPagination: _zhjyPagination.default,
    FunBtn: _funBtn.default,
    ZhjyTable: _zhjyTable.default
  }
};